import React from 'react';
import { useTranslation } from 'react-i18next';
import { BreadcrumbForOwners, ForOwnersContent } from '../common';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';

const ForOwnersComponent = () => {
  const { t } = useTranslation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const breadCrumb = [
    { title: t('for_owners.home'), url: '/' },
    { title: t('for_owners.for_owners'), url: '/for-owners' },
  ];
  return (
    <>
      <BreadcrumbForOwners breadCrumb={breadCrumb} />
      <ForOwnersContent showLoader={showLoader} hideLoader={hideLoader} />
      {loader}
    </>
  );
};

export default ForOwnersComponent;
